export default __webpack_public_path__ + "static/media/18.4fbf50c1.jpg";